import React, { FC, HTMLAttributes } from "react";
import st from './LoadingBox.module.scss';
import cn from "classnames";
import LoadingAnimation from "@assets/lottie/loading_blue.json";
import { Player } from "@lottiefiles/react-lottie-player";

interface ILoadingBox extends HTMLAttributes<HTMLDivElement> {
    borderRadius?: string
}

const LoadingBox: FC<ILoadingBox> = ({ borderRadius, style }) =>{
    return(
        <div style={style} className={cn(st.loadingbox__container, borderRadius && st['loadingbox__container--' + borderRadius + '-radius'])}>
            <div className={st.loadingbox__content}>
                <Player
                    className={st.loadingbox__animation}
                    src={LoadingAnimation}
                    loop
                    autoplay></Player>
                <span>Загрузка данных...</span>
            </div>
        </div>
    )
}
export default LoadingBox;
